<template>
  <span>
    <b-button :size="buttonSize" :style="buttonSize === 'xs' ? 'padding: 0.1rem 1rem;font-size: 0.7875rem;line-height: 1.5;border-radius: 0.2rem' : ''" :disabled="pendingFixedPrices.length === 0" v-b-modal="'modalPendingFixedPrices' + id" v-translate="{qty: pendingFixedPrices.length}">%{qty} Pending Fixed Time Slots/Tours</b-button>

    <b-modal size="lg" :id="'modalPendingFixedPrices' + id" :title="$gettext('Pending Fixed Time Slots')" hide-footer>
      <b-table striped hover
        :items="pendingFixedPrices"
        :fields="[{key: 'type', label: $gettext('Type')}, {key: 'from_date', label: $gettext('From Date')}, {key: 'to_date', label: $gettext('To Date')}, {key: 'amount', label: $gettext('Amount')}]"
      >
        <template v-slot:cell(type)="row">
          <b-badge :variant="row.value === 'tour' ? 'secondary' : 'primary'" style="text-transform: uppercase">{{row.value}}</b-badge>
          <div v-if="row.value === 'tour'" style="white-space: nowrap">
            <strong v-translate>Tour ID:</strong>
            <a :href="'/edit/tours/' + row.item.fixed_tour.tour_id" target="_blank">{{row.item.fixed_tour.tour_id | uuid }}</a>
            <a href="#" @click.prevent="copyToClipboard(row.item.fixed_tour.tour_id)" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
          </div>
        </template>

        <template v-slot:cell(from_date)="row">
          {{moment.utc(row.value).tz($tz).format('L LT')}}
          <small v-if="row.item.type === 'tour'">
            (<abbr :title="$gettext('Estimated')" v-translate>Est.</abbr>)
          </small>
        </template>

        <template v-slot:cell(to_date)="row">
          {{moment.utc(row.value).tz($tz).format('L LT')}}
          <small v-if="row.item.type === 'tour'">
            (<abbr :title="$gettext('Estimated')" v-translate>Est.</abbr>)
          </small>
        </template>

        <template v-slot:cell(amount)="row">
          {{row.item.amount}} {{row.item.currency}}
          <div v-if="row.item.type === 'tour'">
            <span v-translate="{hours: row.item.fixed_tour.fixed_hours}"><abbr title="Estimated">Est.</abbr> Hours: %{hours}</span><br>
            <span v-translate="{maxExtraHours: row.item.fixed_tour.max_extra_hours, price: row.item.fixed_tour.extra_hour_price}"><abbr title="Maximum Extra Hours">M.E.H.</abbr>: %{maxExtraHours} <small>(%{price}/Hour)</small></span>
          </div>
        </template>
      </b-table>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: 'PendingFixedPrices',
  props: {
    pendingFixedPrices: {
      type: Array,
      default: [],
      required: true
    },
    id: {
      type: [String, Number],
      default: null
    },
    buttonSize: {
      type: String,
      default: 'sm'
    }
  }
}
</script>
